import { useEffect, useState } from "react";
import { QueryClient } from "@tanstack/react-query";
import mainStore from "./MainStore/store";
import { check_inFrame } from "./RouterUtils";
// import EmbedContext from "./embed/embedContext";
// import { useSelector } from "react-redux";
// import { useContext } from "react";

export const loadSemrushScript = () => {
  // @deprecated
  // Set JWT on initial load for semrush from Semrush SDK
  if (!check_inFrame()) {
    // redirect to semrush app since semrush host is not allowed iframe
    // window.location.href = "https://www.semrush.com/app/ai-social-content-generator/";
  } else {
    const semrushScript = document.createElement("script");
    semrushScript.src = "https://static.semrush.com/app-center/sdk.js";
    semrushScript.async = true;
    semrushScript.onload = () => {
      // semrush script loaded
      window.SM.init()
        .then(async () => {
          // "SM" variable is available now.
          const jwt = await window.SM.client("getAccessToken");
          mainStore.dispatch({ type: "setJWT", payload: jwt });
          try {
            localStorage.setItem("jwt", jwt);
          } catch (error) {
            console.log("no localstorage allowed");
          }
          // SM.setAutoHeightUpdate({ enable: true })
        })
        .catch(() => console.log("error in init"));
    };
    // semrushScript.setAttribute('src', 'https://static.semrush.com/app-center/sdk.js');
    document.head.appendChild(semrushScript);
  }
};

export const loadKompassifyScript = () => {
  const kompassifyScript = document.createElement("script");
  kompassifyScript.type = "text/javascript";
  window.KOMPASSIFY_ACCOUNT_ID = "8c200c18-beea-4d4d-8065-a26430e269d5";
  kompassifyScript.src =
    "https://player.kompassify.com/kompassifyPlayer.js?uuid=8c200c18-beea-4d4d-8065-a26430e269d5";
  kompassifyScript.async = true;
  document.head.appendChild(kompassifyScript);
  return new Promise((resolve, reject) => {
    kompassifyScript.onload = () => {
      resolve();
    };
    kompassifyScript.onerror = () => {
      reject();
    };
  });
};
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false // default: true,
    }
  }
});

export function useOnlineStatus(pingUrl = "https://predis.ai/_online/") {
  const [isOnline, setIsOnline] = useState("online");

  useEffect(() => {
    let intervalId;

    const checkConnection = async () => {
      if (!navigator.onLine) {
        setIsOnline("offline");
        return;
      }

      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);

        // const url = new URL(pingUrl);
        // url.searchParams.append("r", Math.random().toString(36).substring(2));
        await fetch(pingUrl, {
          method: "GET",
          mode: "no-cors",
          cache: "no-store",
          signal: controller.signal
        });

        clearTimeout(timeoutId);
        setIsOnline("online");
      } catch {
        setIsOnline("unstable");
      }
    };

    // Initial check
    checkConnection();

    // Re-check every 20s
    intervalId = setInterval(checkConnection, 20000);

    // Listen to navigator.onLine events for instant updates
    const goOnline = () => checkConnection();
    const goOffline = () => setIsOnline("offline");

    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, [pingUrl]);

  return isOnline;
}
